import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AlertState, CommonState } from "./types";

export const name = "common";

const initialState: CommonState = {
  alert: {
    show: false,
    type: null,
    messages: null,
    for: "page",
  },
};

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clearAlert: (state) => {
      return {
        ...state,
        alert: initialState.alert,
      };
    },
    setAlert: (state, action: PayloadAction<Partial<AlertState>>) => {
      state.alert = {
        ...state.alert,
        ...action.payload,
      };
    },
  },
});

export const actions = slice.actions;

export default slice.reducer;
